import React from "react";
import { Bar } from "react-chartjs-2";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import assetHomeIcon from "../../../assets/images/goal.png";
import moment from "moment";
import "../GoalsDashboard/GoalsDashboard.css";
export const GoalsReport = ({ goalsData }) => {
  const extractedModules = goalsData && goalsData.map((item) => item.module);

  function getMonthsDifference(date1, date2) {
    const year1 = date1.getFullYear();
    const year2 = date2.getFullYear();
    const month1 = date1.getMonth();
    const month2 = date2.getMonth();

    return (year2 - year1) * 12 + (month2 - month1);
  }
  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed
      ? amountNeed
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    let GoalDate = date
      ? new Date(date)
      : new Date();
      if (!(GoalDate instanceof Date)) {
        GoalDate = new Date(GoalDate);
      }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    console.log("result", result);
    return parseFloat(result).toFixed(2);
  };
  const extractedDollarAmounts =
    goalsData &&
    goalsData.map((item) =>
      item["Dollar Amount Needed"] ? calculateGoalNeed(item["Dollar Amount Needed"] ,item["Goal Date"] ? item["Goal Date"] : new Date()) : 0
    );
    const extractedGoalHaveAmount =
    goalsData &&
    goalsData.map((item) => {
      // Calculate the sum from assignAssets
      const assetsAmount = item.assignAssets && Array.isArray(item.assignAssets)
        ? item.assignAssets.reduce(
            (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
            0
          )
        : 0;
  
      // Calculate the sum from Amount Received
      const receivedAmount = item["Amount Received"] && Array.isArray(item["Amount Received"])
        ? item["Amount Received"].reduce((acc, curr) => acc + parseFloat(curr || 0), 0)
        : 0;
  
      // Return the total "Have Amount"
      return assetsAmount + receivedAmount;
    });
    console.log("goalsData",goalsData)
    const needHaveDifferenceArray =
      goalsData &&
      goalsData.map((item) => {
        const needAmount = item["Dollar Amount Needed"]
          ? calculateGoalNeed(
              item["Dollar Amount Needed"],
              item["Goal Date"] ? item["Goal Date"] : new Date()
            )
          : 0;

      const haveAmount = item.assignAssets && Array.isArray(item.assignAssets) 
      ? item.assignAssets.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0)
      : 0;
      const receivedAmount = item["Amount Received"] && Array.isArray(item["Amount Received"])
        ? item["Amount Received"].reduce((acc, curr) => acc + parseFloat(curr || 0), 0)
        : 0;
      console.log("itemmmm",item)

    return Math.max(0, needAmount - (haveAmount+receivedAmount));;
  });

  // console.log("needHaveDifferenceArray",needHaveDifferenceArray,extractedDollarAmounts,extractedGoalHaveAmount);
  const data = {
    labels: extractedModules && extractedModules,
    datasets: [
      {
        label: "Have",
        data: extractedGoalHaveAmount && extractedGoalHaveAmount,
        fill: false,
        backgroundColor: "#B1E3FF",
        borderColor: "#B1E3FF",
      },
      {
        label: "Need",
        data: needHaveDifferenceArray && needHaveDifferenceArray,
        fill: false,
        backgroundColor: "#2A3DA3",
        borderColor: "#2A3DA3",
      },
    ],
  };
  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "white",
        formatter: (value, context) => `${value}%`,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true, // This will ensure the y-axis starts from 0
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(value);
            },
          },
        },
      ],
    },
    tooltips: {
      // enabled: false,
      callbacks: {
        label: (tooltipItem, data) => {
          // Get the dataset label, global label or fall back to empty label
          let label =
            (data.datasets[tooltipItem.datasetIndex].labels &&
              data.datasets[tooltipItem.datasetIndex].labels[
                tooltipItem.index
              ]) ||
            data.datasets[tooltipItem.datasetIndex].label ||
            data.labels[tooltipItem.index] ||
            "";
          if (label) {
            label += ": ";
          }

          // Apply the value and suffix
          label +=
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
            (data.datasets[tooltipItem.datasetIndex].labelSuffix || "");

          return label;
        },
      },
    },
    // legend: {
    //   onClick: () => {}, // Disable legend click
    // },
  };

  return (
    <React.Fragment>
      <div className="GoalsCard1">
        <div className="goal-home-icon-container1">
          <div className="goal-home-icon1">
            <img src={assetHomeIcon} alt="" />
          </div>
          <h3 className="GoalReportheading">Goals Report</h3>
        </div>
        <div className="GoalRow">
          <div>
            <p className="goalReportPara">Detailed listings of Assets</p>
          </div>
          <div>
            <div className="GoalReportrow">
              <div className="goalReportrowData">
                <span className="goalReportTitle"> Client Name</span>
                <span className="goalReportsubTitle">
                  {" "}
                  {localStorage.getItem("User") ? (
                    localStorage.getItem("User")
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </span>
              </div>
              <div className="goalReportrowData">
                <span className="goalReportTitle"> Plan Nickname </span>
                <span className="goalReportsubTitle"> First Plan</span>
              </div>
            </div>
            <div className="goalreportrow2">
              <div className="goalReportrowData">
                <span className="goalReportTitle"> Today's Date </span>
                <span className="goalReportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="goalCard2" style={{ position: "relative" }}>
        <h1 className="GoalsCardheading">Goals</h1>
        <div style={{ marginTop: "1rem" }}>
          <Bar
            data={data}
            height={300}
            options={options}
            // options={{
            //   legend: {
            //     display: false,
            //   },
            //   maintainAspectRatio: false,
            //   responsive: true,
            //   scales: {
            //     xAxes: [
            //       {
            //         gridLines: {
            //           color: "rgba(0, 0, 0, 0)",
            //         },
            //       },
            //     ],
            //     yAxes: [
            //       {
            //         ticks: {
            //           beginAtZero: true, // This will ensure the y-axis starts from 0
            //           callback: function (value) {
            //             return new Intl.NumberFormat("en-US", {
            //               style: "currency",
            //               currency: "USD",
            //               minimumFractionDigits: 0,
            //               maximumFractionDigits: 0,
            //             }).format(value);
            //           },
            //         },
            //       },
            //     ],
            //   },
            // }}
          />
        </div>
        {/* <NewLoader isLoading={loading} /> */}
      </div>
    </React.Fragment>
  );
};
